export default __webpack_public_path__ + "static/media/spiral.4063bb48.png";